module.exports = __webpack_public_path__ + "assets/img/img-welfare-03.58113416.jpg";